
const Details = (target) => {

  const el = {
    details: target,
    buttons: target.querySelectorAll(".button:not(.button--back)"),
  };

  const method = {

    init: () => {
      el.buttons.forEach((button) => {
        button.addEventListener("mouseover", () => {
          el.details.classList.add("details--hovered");
        });

        button.addEventListener("mouseout", () => {
          el.details.classList.remove("details--hovered");
        });
      });
    },
  };

  method.init();
};

export default Details;
